export function isFirstCard(rateCard) {
  return rateCard.start == null;
}

export function coveringCard(rateCards, date) {
  return (
    (rateCards ?? []).find(
      (rateCard) => (!rateCard.start || rateCard.start <= date) && (!rateCard.end || rateCard.end >= date),
    ) ?? null
  );
}

export function describeWindow(rateCard, dateTimeFormat) {
  const start = rateCard.start ? dateTimeFormat.format(rateCard.start) : 'Project start';
  const end = rateCard.end ? dateTimeFormat.format(rateCard.end) : 'ongoing';

  return `${start} to ${end}`;
}
